export const UNKNOWN_ERROR_TYPE = 'UNKNOWN_ERROR_TYPE'

declare module ':/@common/result' {
  export interface MATHFLAT_RESULT_TYPES {
    UNKNOWN_ERROR_TYPE: typeof UNKNOWN_ERROR_TYPE
  }
}

/**
 * 성공 또는 실패를 나타내는 타입
 */
export type Result<T, E = string> = { success: true; data: T } | { success: false; error: E }
